"use client"

import clsx from "clsx"
import { NpHomePageFeatures } from "src/components/home/NpHomePageFeatures"
import { NpProductCarousel } from "src/components/home/NpProductCarousel"
import { NpHomePageFeatureData, NpHomePageProductData } from "src/components/home/types"
import { npPagePxClassName, npSectionMtClassName } from "src/components/np-design/components/constants"
import { NpUppercaseHeading } from "src/components/np-design/components/NpUppercaseHeading"

export const featuredProductsSectionId = "featured-products"

export type NpCategoryFeaturedProductsSectionProps = {
  heading: string
  features: NpHomePageFeatureData[]
  products: NpHomePageProductData[]
}

export const NpCategoryFeaturedProductsSection = ({
  heading,
  features,
  products,
}: NpCategoryFeaturedProductsSectionProps) => {
  return (
    <section
      id={featuredProductsSectionId}
      className={clsx(npSectionMtClassName, npPagePxClassName, "flex flex-col items-center gap-10")}
    >
      <NpUppercaseHeading as="h2">{heading}</NpUppercaseHeading>

      <div className="flex w-full flex-col items-center gap-10 overflow-hidden">
        <NpHomePageFeatures features={features} maxDisplayed={6} />
        <NpProductCarousel products={products} listId="category_featured_products" />
      </div>
    </section>
  )
}
